<template>
  <div class="font" >
    <b-container class='px-0'>
      <b-row class='mt-2 border-orange p-5'>
        <b-col cols='12' class=' pb-2'>
          <h4> {{ jobInfo.title }} </h4>
        </b-col>
        <b-col cols='12' class=' mt-3'>
          <label >● 業種 </label><br>
          <label >{{ INDUSTRY_DICTIONARY[jobInfo.industry] }} </label><br>

          <label >● 職種 </label><br>
          <label >{{ emStatusOptions[jobInfo.occupation] }} </label><br>

          <label >● 給与 </label><br>
          <label >{{ salaryOptions[jobInfo.employment_form] }} {{ jobInfo.salary_from }}万円 〜 {{ jobInfo.salary_to }}万円 </label><br>

          <label >● 勤務時間 </label><br>
          <label >{{ WORKTIME[start_time] }} 〜 {{ WORKTIME[end_time] }}</label><br>

          <label >● 勤務地 </label><br>
          <label >{{ jobInfo.location }} </label><br>

          <label >● 仕事内容及びアピールポイント </label><br>
          <label >{{ jobInfo.description }} </label><br>

          <label >● 応募資格 </label><br>
          <label >{{ jobInfo.qualification }} </label><br>

          <label >● 求める人材 </label><br>
          <label >{{ jobInfo.human_resource }}</label><br>

          <label >● 採用人数 </label><br>
          <label >{{ jobInfo.number_of_hires }}人 </label><br>

          <label >● 独身者・既婚者・不問 </label><br>
          <label >{{ MARRIEDLIST[jobInfo.married_type] }} </label><br>

          <label >● 日本語レベル </label><br>
          <label >{{ JAPANESELIST[jobInfo.japanese_level] }}</label><br>

          <label >● 希望国籍 </label><br>
          <label >{{ HOPELIST[jobInfo.hope_of_country] }}</label><br>

          <label >● 学歴 </label><br>
          <label >{{ EDUCARIONALLIST[jobInfo.educational_background] }} </label><br>

          <label >● 国外からの応募可否 </label><br>
          <label >{{ OVERSEASLIST[jobInfo.apply_from_overseas] }} </label><br>

          <label >● 休憩時間 </label><br>
          <label >{{ jobInfo.break_time }} </label><br>

          <label >● 月残業時間 </label><br>
          <label >{{ jobInfo.overtime }}</label><br>

          <label >● 休日 </label><br>
          <label >{{ BREAKTIMELIST[jobInfo.holiday] }}</label><br>

          <label >● 労務管理 </label><br>
          <label >{{ jobInfo.labor_management }}</label><br>

          <label >● 賃金台帳 </label><br>
          <label >{{ jobInfo.wage_ledger }}</label><br>

          <label >● 出勤簿 </label><br>
          <label >{{ jobInfo.attendance_record }} </label><br>

          <label >● 賃金台帳作成担当者 </label><br>
          <label >{{ jobInfo.wage_ledger_creator }} </label><br>

          <label >● 賃金台帳作成方法 </label><br>
          <label >{{ WAGELIST[jobInfo.way_create_wage_ledger] }} </label><br>

          <label >● 就労時間管理 </label><br>
          <label >{{ TIMEMANAGEMENTLIST[jobInfo.working_time_management] }}</label><br>

          <label >● 食事関係 </label><br>
          <label >{{ MEALLIST[jobInfo.meal_related] }} (毎月の徴収費用 {{ jobInfo.facilities_equipment }})</label><br>

          <label >● 作業着 </label><br>
          <label >{{ WORKCLOTHLIST[jobInfo.work_clothes] }} </label><br>

          <label >● 保護具 </label><br>
          <label >{{ WORKCLOTHLIST[jobInfo.protective_equipment] }} </label><br>

          <label >● 宿泊施設概要 </label><br>
          <label >{{ jobInfo.accommodation_overview }} </label><br>

          <label >● 宿泊施設場所 </label><br>
          <label >{{ PLACELIST[jobInfo.place] }}</label><br>

          <label >● 宿泊施設名 </label><br>
          <label >{{ jobInfo.accommodation_name }}</label><br>

          <label >● 宿泊施設所在地 </label><br>
          <label >{{ jobInfo.accommodation_location }}</label><br>

          <label >● 部屋面積 </label><br>
          <label >{{ jobInfo.room }} m<sup>2</sup></label><br>

          <label >● 部屋収容人数 </label><br>
          <label >{{ room_capacity }} 名</label><br>

          <label >● 一人当たりの居室 </label><br>
          <label >{{ room_per_person }} </label><br>

          <label >● 徴収費用 住居費 </label><br>
          <label >月額{{ living_cost }}円</label><br>

          <label >● 徴収費用 水道光熱費 </label><br>
          <label >{{ CollectionFeeDict[jobInfo.utility_cost] }}</label><br>

          <label >● 徴収費用 通信費 </label><br>
          <label >{{ CollectionFeeDict[jobInfo.communication_cost] }}</label><br>

          <label >● 交通アクセス(宿泊施設から職場までの所要時間) </label><br>
          <label >{{ access_minute }}分</label><br>

          <label >● 交通アクセス(方法) </label><br>
          <label >{{ access_way }}</label><br>

          <label >● 引っ越し代の負担 </label><br>
          <label >{{ MOVINGLIST[jobInfo.moving_fee] }}</label><br>

          <label >● 待遇・福利厚生 </label><br>
          <label >{{ jobInfo.walfare }} 名</label><br>

          <label >● その他 </label><br>
          <label >{{ jobInfo.other }} </label><br>

          <label >● 働き方紹介画像 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in jobInfo.images' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 募集背景 </label><br>
          <label >{{ jobInfo.background }}</label><br>

          <label >● 入社後の流れ </label><br>
          <label >{{ jobInfo.after_joining }}</label><br>

          <label >● 会社外写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.outside_office_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 会社内写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.within_office_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 該当仕事写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.working_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 社員写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.employee_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 寮部屋外写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.outside_dormitory_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>

          <label >● 寮部屋内写真 </label><br>
          <b-row>
            <b-col cols='5' class='pr-4' v-for='(image, index) in (jobInfo.within_dormitory_image)' :key='index'>
              <img :src="image" class="w100">
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row class='mt-4 text-center'>
        <b-col cols='5' class='mx-auto'>
          <b-button pill class='bg-orange mr-5' @click='notConfirm'>{{$t("message.retry_edit")}}</b-button>
          <b-button pill class='bg-orange' @click='createJob'>登録する</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  props:{
    jobInfo: {},
  },
  data () {
    return {
      jobId: this.$route.params.jobId,
      min_salary: '',
      max_salary: '',
      start_time: '',
      end_time:'',
      room_capacity: 0,
      room_per_person: 0,
      access_way: '',
      access_minute: '',
      living_cost: '',
      posting_start_date: '',
      posting_start_time: '',
      posting_end_date: '',
      posting_end_time: '',
      emStatusOptions: {
        full: this.$i18n.t('message.full_time_employee'),
        part: this.$i18n.t('message.part_time_job'),
        temporary: this.$i18n.t('message.temporary_staff'),
        contract: this.$i18n.t('message.contract_employee')
      },
      publicOptions: {
        public: this.$i18n.t('message.public'),
        private: this.$i18n.t('message.private')
      },
      salaryOptions: {
        'hourt': '時給' ,
        'week': '週給',
        'month': '月給' ,
        'year': '年収' ,
      },
    }
  },
  methods:{
    notConfirm(){
      this.$emit('back')
    },
    createJob(){
      this.$emit('createJob')
    }
  },
  mounted(){
    console.log(this.jobInfo)
    if(this.jobInfo.salary != null){
      var salary_list = this.jobInfo.salary.split('~')
      this.min_salary = salary_list[0]
      this.max_salary = salary_list[1]
    }
    if(this.jobInfo.working_hours != null){
      var working_hours_list = this.jobInfo.working_hours.split('~')
      this.start_time = working_hours_list[0]
      this.end_time = working_hours_list[1]
    }

    if(this.jobInfo.facility != null){
      var facility_list = this.jobInfo.facility.split(',')
      this.room_capacity = facility_list[0]
      this.room_per_person = facility_list[1]
    }
    if(this.jobInfo.collection_fee != null){
      var fee_list = this.jobInfo.collection_fee.split(',')
      this.living_cost = fee_list[0]
    }
    if(this.jobInfo.access != null){
      var access_list = this.jobInfo.access.split(',')
      this.access_minute = access_list[0]
      this.access_way = access_list[1]
    }

    if(this.jobInfo.posting_time != null){
      var posting_start_time_list = this.jobInfo.posting_time.split(',')
      this.posting_start_date = posting_start_time_list[0]
      this.posting_start_time = posting_start_time_list[1]
    }

    if(this.jobInfo.posting_end_time != null){
      var posting_end_time_list = this.jobInfo.posting_end_time.split(',')
      this.posting_end_date = posting_end_time_list[0]
      this.posting_end_time = posting_end_time_list[1]
    }

    if(this.jobInfo.images[0] != null & this.jobInfo.images != ""){
      this.jobInfo.images = this.jobInfo.images.split(',')
    }

    if(this.jobInfo.within_office_image[0] != null & this.jobInfo.within_office_image != ""){
      this.jobInfo.within_office_image = this.jobInfo.within_office_image.split(',')
    }

    if(this.jobInfo.outside_office_image[0] != null & this.jobInfo.outside_office_image != ""){
      this.jobInfo.outside_office_image = this.jobInfo.outside_office_image.split(',')
    }

    if(this.jobInfo.working_image[0] != null & this.jobInfo.working_image != ""){
      this.jobInfo.working_image = this.jobInfo.working_image.split(',')
    }

    if(this.jobInfo.employee_image[0] != null & this.jobInfo.employee_image != ""){
      this.jobInfo.employee_image = this.jobInfo.employee_image.split(',')
    }

    if(this.jobInfo.outside_dormitory_image[0] != null & this.jobInfo.outside_dormitory_image != ""){
      this.jobInfo.outside_dormitory_image = this.jobInfo.outside_dormitory_image.split(',')
    }

    if(this.jobInfo.within_dormitory_image[0] != null & this.jobInfo.within_dormitory_image != ""){
      this.jobInfo.within_dormitory_image = this.jobInfo.within_dormitory_image.split(',')
    }
  }
}

</script>
<style scoped lang="scss">
.commonStyle{
  padding: 1rem;
  text-align:center;
  background-repeat: no-repeat !important;
}
.styleA{
  border:3px dotted gray;
  background-color: #F5F5F8 !important;
  background-size: contain !important;
  background-repeat : no-repeat !important;
}

.isImage{
  min-height: 200px;
  background-position : center !important;
}
.border-orange{
  border: 2px solid orange;
  border-radius: 1rem;
}
.w100 {
  width: 100%;
}
</style>
